const routes = [
  {
    path: '/clients',
    name: 'Clients',
    redirect: { name: 'Service' },
    component: {
      render: (r) => r('router-view')
    },
    children: [
      {
        path: 'service',
        name: 'Service',
        component: {
          render: (r) => r('h1', 'Clientes')
        }
      }
    ]
  }
]

export default routes
